import { render, staticRenderFns } from "./measureIndex.vue?vue&type=template&id=bd6da472&scoped=true&"
import script from "./measureIndex.vue?vue&type=script&lang=js&"
export * from "./measureIndex.vue?vue&type=script&lang=js&"
import style0 from "./measureIndex.vue?vue&type=style&index=0&id=bd6da472&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd6da472",
  null
  
)

export default component.exports